import { ITab, Tabs } from "components/tabs/Tabs";

export enum tabValues {
  FOR_YOU = "forYou",
  TRENDING = "trending",
}

const TABS: ITab[] = [
  {
    value: "forYou",
    label: "For You",
  },
  {
    value: "trending",
    label: "Trending",
  },
];

interface IProps {
  tab: string;
  onChange: (code: string) => void;
}

export const HomeTab = ({ tab, onChange }: IProps) => {
  return (
    <Tabs value={tab} list={TABS} onChange={onChange}/>
  );
};
